export class AdminService {
  getHeaders = {
    "Content-type": "application/json",
  }
  constructor() {
  }

  authHeaders() {
    const jwt = window.novasectorapp.getJWT()
    return {
      "Content-type": "application/json",
      "Autorization": "Token " + jwt
    }
  }

  baseURL() {
    let url_base = 'https://novasector.net/v1/'
    // change to development env if needed
    if (process.env.NODE_ENV === 'development')
      url_base = 'http://localhost:4200/v1/'
    return url_base
  }

  async admin_login(form) {
    const url = this.baseURL() + 'admin_login'
    const pkg = JSON.stringify({ admin: form })

    const res = await fetch(url,{
      method: "POST",
      body: pkg,
      headers: this.getHeaders
    })

    const body = await res.json().catch(() => ({}))
    if (res.status < 200 || res.status >= 300) {
      return {
        status: body.status || "error",
        pkg: body.pkg || "Admin login failed."
      }
    }
    return body
  }

  async admin_logout() {
    const url = this.baseURL() + 'admin_logout'
    await fetch(url, {
      method: 'POST',
      headers: this.authHeaders()
    }).then((res) => res.json())
        .then((pkg) => console.log('logout status:', pkg.message))
  }

  async add_user(user) {
    const res = await fetch(this.baseURL() + 'admin/user/add', {
      method: 'POST',
      headers: this.authHeaders(),
      body: JSON.stringify({ user })
    })
    const pkg = await res.json().catch(() => ({}))
    if (!res.ok) return { errors: pkg.errors || 'Add user failed' }
    return pkg
  }

  remove_user(user) {
    const url = this.baseURL() + 'admin/user/remove'

    return fetch(url, {
      method: 'POST',
      headers: this.authHeaders(),
      body: JSON.stringify({ user })
    }).then((res) => res.json())
  }

  update_user(user) {
    const url = this.baseURL() + 'admin/user/update'

    return fetch(url, {
      method: 'POST',
      headers: this.authHeaders(),
      body: JSON.stringify({ user })
    }).then((res) => res.json())
  }

}


